<template>
  <div class="center">
    <v-layout row justify-center>

      <v-card flat max-width="400">
        <v-card-title primary-title>
          <div class="center">
            <span class="headline mb-0 pl-2">联系信息</span>
          </div>
        </v-card-title>
        <div style="padding-bottom:25px;"></div>
        <div>
          <p><i class="fa fa-phone"></i>&nbsp;&nbsp;626-390-8870</p>
          <p><i class="fa fa-envelope"></i>&nbsp;&nbsp;juliazhao@remax.net</p>
          <p>RE/MAX Elite Realty<br/>842 E. Valley Blvd, Alhambra, CA 91801</p>
        </div>
        <div style="min-height:450px;">
          <form name="sendMessage">
            <v-text-field
              id="name"
              v-model="name"
              :rules="[rules.required]"
              label="您的姓名 *"
              required
            ></v-text-field>

            <v-text-field
              id="email"
              v-model="email"
              :rules="[rules.required]"
              label="您的邮箱 *"
              required
            ></v-text-field>
            <v-text-field
              id="phone"
              v-model="phone"
              :rules="[rules.required]"
              label="您的电话号码 *"
              required
            ></v-text-field>
            <v-textarea id="message" v-model="message"
                        auto-grow
                        label="请留言 *"
                        :rules="[rules.required]"
                        required
                        rows="1">

            </v-textarea>
            <v-btn light type="submit">发送</v-btn>
          </form>
        </div>
      </v-card>


    </v-layout>
  </div>
</template>

<script>
  import contact from '../../contact'

  export default {
    name: "contact",
    data() {
      return {
        valid: true,
        name: null,
        email: null,
        phone: null,
        message: null,
        rules: {
          required: value => !!value || ' '
        }
      }
    },
    methods: {
      submit(){
        let my = this
        contact.post('http://juliazhao.com/realestate/contact.php', {
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message
        }, function (resp) {
          if(resp.status===200 && resp.data === 'success') {
            my.success = '发送成功'
          } else {
            my.err = '发送失败，请检查所填写的信息重试。'
          }
        }, function (err) {
          my.err = err.message?err.message:err
        })
      }
    }
  }
</script>

<style scoped>

</style>
